import { getYear } from "date-fns";
import { useMemo } from "react";
import { Ctp_SrSeasonType } from "@/graphql/gql/graphql";
import useGetHeadToHeadPlayerStats from "@/utils/hooks/useGetHeadToHeadPlayerStats";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import { playerToStatistics } from "./util";

export default function usePlayerStatistics() {
  const { gameId } = useHeadToHeadContext();
  const { data, isLoading, isError, refetch } =
    useGetHeadToHeadPlayerStats(gameId);

  const players = useMemo(
    () =>
      [
        ...(data?.event?.homeTeam?.players ?? []),
        ...(data?.event?.awayTeam?.players ?? []),
      ].map((player) =>
        playerToStatistics(player, data?.event?.season ?? getYear(new Date()))
      ),
    [data]
  );

  const regularSeason = data?.ctp_nfl?.seasonMeta?.seasonStructure?.find(
    (structure) => structure?.seasonType === Ctp_SrSeasonType.Regular
  );
  const weekOneEnd = regularSeason?.weeks?.find(
    (week) => week?.week === 1
  )?.lastGameTime;

  return { players, weekOneEnd, isLoading, isError, refetch };
}
